module.exports = __webpack_public_path__ + "media/application/images/2018/rd-2020-footer-twitter-e6aa4d3ea065b9cbd5eecb3c80bc8b31.png";